import React from 'react';
import PropTypes from 'prop-types';

const getButtonClass = props => {
  const style = [];
  if (props.useBareClass) return style;
  if (!props.secondary && !props.textLink) style.push('ncss-btn-primary-dark');
  if (props.secondary) style.push('ncss-btn-secondary-dark');
  if (props.textLink) {
    style.push('text-underline body-3 text-color-primary-dark');
  }

  if (props.extraClassName) style.push(props.extraClassName);

  return style.join(' ');
};

// This is a tactic for keeping extra props from getting to the wrapped element
// See https://facebook.github.io/react/warnings/unknown-prop.html for details
const Button = ({ extraClassName, secondary, textLink, matchCase, submit, useBareClass, children, ...rest }) =>
  children ? (
    <button
      // eslint-disable-next-line react/button-has-type
      type={rest.type}
      {...{
        // type: submit ? 'submit' : 'button',
        ...rest,
        className:
          rest.className ||
          getButtonClass({
            ...rest,
            secondary,
            textLink,
            matchCase,
            extraClassName
          })
      }}
    >
      {children}
    </button>
  ) : null;

Button.defaultProps = {
  extraClassName: null,
  matchCase: false,
  secondary: false,
  submit: null,
  textLink: false,
  useBareClass: false,
  children: null
};

Button.propTypes = {
  children: PropTypes.node,
  extraClassName: PropTypes.string,
  matchCase: PropTypes.bool,
  secondary: PropTypes.bool,
  submit: PropTypes.func,
  textLink: PropTypes.bool,
  useBareClass: PropTypes.bool
};

export default Button;
